define('ProductDetails.Extension', ['ProductDetails.Downloads.View', 'ItemPDF.Model'], function (
  ProductDetailsDownloadsView,
  ItemPDFModel
) {
  'use strict';

  return {
    mountToApp: function (container) {
      var layout = container.getComponent('Layout');

      if (!layout) return;

      layout.registerView('ProductDetails.Downloads.View', function () {
        return new ProductDetailsDownloadsView({
          model: new ItemPDFModel()
        });
      });
    }
  };
});
